import api from './api'

export default {
  autenticar(body){
    return api().get(`/autenticacao/${body}`, {})
  },
}